export const locale = {
  path: 'locales/client.json',
  langCode: 'nb',
};
